module.exports = __webpack_public_path__ + "static/media/ils_covid_success_myway.abea5bfe.svg";